import { useSwitchState } from 'hooks/useSwitchState'
import type { DialogProps } from '@radix-ui/react-dialog'
import { FC, PropsWithChildren, useState } from 'react'
import {
  cn,
  Button,
  Dialog as DialogUI,
  DialogContent as DialogContentUI,
} from '@wellesley/ui'

type TModalButtonProps = PropsWithChildren & {
  modalTitle: string
  modalSlug?: string
  buttonText?: string
}

type TDialogContentProps = TModalButtonProps &
  DialogProps & {
    onCloseModal?: () => void
  }

const TITLE_HEIGHT = 65

export const Dialog: FC<TDialogContentProps> = ({
  children,
  open,
  modalTitle,
  defaultOpen = true,
  onOpenChange,
  onCloseModal,
}) => {
  const [scroll, setScroll] = useState(0)

  const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
    setScroll(event.currentTarget.scrollTop)
  }

  const showTitle = scroll > TITLE_HEIGHT

  return (
    <DialogUI open={open} defaultOpen={defaultOpen} onOpenChange={onOpenChange}>
      <DialogContentUI
        overlayClassName="bg-transparent"
        title={showTitle ? modalTitle : undefined}
        className="max-w-[70vw]"
        closeSize="small"
        closeVariant="insideCard"
        onCloseModal={onCloseModal}
        childrenClassName={cn(
          'overflow-auto w-full relative !p-0 h-screen',
          showTitle ? 'max-h-[calc(90vh-65px)]' : 'max-h-[90vh]',
        )}
        onScroll={handleScroll}
      >
        <div className="px-[80px] py-[44px]">{children}</div>
      </DialogContentUI>
    </DialogUI>
  )
}

const ModalWithButton: FC<TModalButtonProps> = ({
  modalTitle,
  buttonText = modalTitle,
  children,
}) => {
  const [isOpen, openModal, closeModal] = useSwitchState()

  const handleOpenModal = () => {
    // TODO: should be implemented with global routing
    // if (modalSlug) {
    //   const w = window.parent || window
    //   const currentPath = w.location.pathname.replace(/\/+$/, '')
    //   const newPath = `${currentPath}/${modalSlug}`
    //   w.parent.history.replaceState(null, '', newPath)
    // }
    openModal()
  }

  const handleCloseModal = () => {
    // TODO: should be implemented with global routing
    // if (modalSlug) {
    //   const w = window.parent || window
    //   const currentPath = w.parent.location.pathname
    //   const newPath = currentPath.replace(/\/[^/]+$/, '')
    //   w.parent.history.replaceState(null, '', newPath)
    // }
    closeModal()
  }

  return (
    <>
      <Button
        variant="none"
        size="none"
        onClick={handleOpenModal}
        className="m-0 !p-0 text-sm font-normal"
      >
        {buttonText}
      </Button>

      <Dialog
        open={isOpen}
        onOpenChange={(opened) => {
          if (!opened) handleCloseModal()
        }}
        defaultOpen={isOpen}
        modalTitle={modalTitle}
        onCloseModal={handleCloseModal}
      >
        {children}
      </Dialog>
    </>
  )
}

export default ModalWithButton
